"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviousNextNavigation = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var PreviousNextNavigation_styled_1 = require("./PreviousNextNavigation.styled");
var PreviousNextNavigation = function (_a) {
    var _b, _c;
    var children = _a.children, previous = _a.previous, next = _a.next;
    var _d = (0, core_1.useComponents)(), Heading1 = _d.Heading1, Icon = _d.Icon;
    return (react_1.default.createElement(PreviousNextNavigation_styled_1.StyledWrapper, null,
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.USAGE_NAVIGATION, properties: (_b = { value: 'prev' }, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(PreviousNextNavigation_styled_1.StyledNavigationLink, { disabled: previous.disabled, "data-testid": "prev-next-nav-prev", "aria-label": previous.label, onClick: previous.onClick },
                react_1.default.createElement(Icon, { name: "chevron-left", size: "4rem" }))),
        react_1.default.createElement(PreviousNextNavigation_styled_1.StyledHeading, { as: Heading1, id: "prev-next-nav-heading" }, children),
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.USAGE_NAVIGATION, properties: (_c = { value: 'next' }, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
            react_1.default.createElement(PreviousNextNavigation_styled_1.StyledNavigationLink, { disabled: next.disabled, "data-testid": "prev-next-nav-next", "aria-label": next.label, onClick: next.onClick },
                react_1.default.createElement(Icon, { name: "chevron-right", size: "4rem" })))));
};
exports.PreviousNextNavigation = PreviousNextNavigation;
